import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=275f7c16&scoped=true"
import script from "./ContactDialog.vue?vue&type=script&lang=js"
export * from "./ContactDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=275f7c16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f7c16",
  null
  
)

export default component.exports